import {Box, styled} from "@mui/material";

export const FormInputLabelBox = styled(Box)`
  display: flex;
  align-items: flex-end;
  gap: 8px;
`;
